const toCapitializeForm = text =>
  text && `${text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()}`;

export default toCapitializeForm;
